<h1 matDialogTitle>Comments</h1>

<mat-dialog-content>
  <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">
    <div fxFlex="100" width="100%" *ngFor="let comment of data">
      <span class="line-number"> {{comment.lineNumber}}.</span>
      <span><b> {{comment.text}}</b></span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Close</button>
</mat-dialog-actions>
